import { render, staticRenderFns } from "./Paginater.vue?vue&type=template&id=4a28d212&scoped=true&"
import script from "./Paginater.vue?vue&type=script&lang=ts&"
export * from "./Paginater.vue?vue&type=script&lang=ts&"
import style0 from "./Paginater.vue?vue&type=style&index=0&id=4a28d212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a28d212",
  null
  
)

export default component.exports